import * as React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import to from 'await-to-js'
import { withRouter } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import { getFormValues } from 'redux-form/immutable'
import { Button } from 'relevant-ui'
import {
  getUpdateProfile,
  activateSecureUserAccount,
} from 'actions/profiles'
import InputField from '@App/components/fields/InputField'

import {
  PROFILE_FORM,
  FIRST_NAME,
  FIRST_NAME_LABEL,
  LAST_NAME,
  LAST_NAME_LABEL,
  EMAIL,
  EMAIL_LABEL,
  PHONE,
  UPDATE_PASSWORD_PROFILE_ROUTE,
  PHONE_LABEL,
} from '@App/constantes'
import { disable2FA, getUserById } from '@App/store/user'
import { setHideModal, setShowFormModal } from '@App/store/modal'

import 'components/forms/form.scss'
import './styles.scss'
import { withTranslation } from 'react-i18next'

class ProfileForm extends React.Component<any, any, any> {
  constructor(props: any) {
    super(props)

    this.state = {
      isActive2FA: props?.user?.has2FA || false,
      isDisable2FA: false,
    }

    this.submitForm = this.submitForm.bind(this)
    this.onHandle2FA = this.onHandle2FA.bind(this)
    this.onHandleUpdatePassword = this.onHandleUpdatePassword.bind(this)

  }

  async submitForm() {
    const {
      user,
      update,
    } = this.props

    const body = {
      id: user.id,
      firstName: this.props[FIRST_NAME],
      lastName: this.props[LAST_NAME],
      email: this.props[EMAIL],
      avatar: null,
      phone: this.props[PHONE],
    }

    const [err] = await to(update(body))

    if (err) {
      return
    }

    return
  }

  async onHandle2FA() {
    const { disable2FA, user } = this.props

    if (!user?.has2FA) {
      this.setState({ isDisable2FA: true })
      this.props.onHandleStep(0)
      this.props.setShowFormModal()

      return
    }

    const [err] = await to(disable2FA())

    if (err) {
      return
    }

    this.setState({ isDisable2FA: false })
    this.props.onHandleStep(0)
    this.props.setShowFormModal()

    return
  }

  onHandleUpdatePassword() {
    this.props.history.push(UPDATE_PASSWORD_PROFILE_ROUTE)
  }

  render() {
    const {
      handleSubmit,
      submitting,
      user,
      t,
    } = this.props

    return (
      <form
        className="form form__connect 2fA_form"
        autoComplete="off"
        onSubmit={handleSubmit(this.submitForm)}
      >
        <div className="form__wrapper customformGroup--noPadding">
          <section className="formWrapper">
            <h4 className="formWrapper__title">{t('edit_profil')}</h4>
            <div className="formWrapper__fields">
              <div className="form__field form__field--small">
                <div className="form__field__label">
                  {t('firstName')}
                </div>
                <div className="form__field__input">
                  <Field
                    component={InputField}
                    name={FIRST_NAME}
                    label={FIRST_NAME_LABEL}
                    secondary
                  />
                </div>
              </div>
              <div className="form__field form__field--small">
                <div className="form__field__label">
                  {t('lastName')}
                </div>
                <div className="form__field__input">
                  <Field
                    component={InputField}
                    name={LAST_NAME}
                    label={LAST_NAME_LABEL}
                    secondary
                  />
                </div>
              </div>
              <div className="form__field form__field--small">
                <div className="form__field__label">
                  {t('email')}
                </div>
                <div className="form__field__input">
                  <Field
                    component={InputField}
                    name={EMAIL}
                    label={EMAIL_LABEL}
                    secondary
                  />
                </div>
              </div>
              <div className="form__field form__field--small">
                <div className="form__field__label">
                  {t('phone')}
                </div>
                <div className="form__field__input">
                  <Field
                    component={InputField}
                    name={PHONE}
                    label={PHONE_LABEL}
                    secondary
                  />
                </div>
              </div>
              <div className="form__field form__field--large button-2FA mt-10">
                <Button
                  button="primary"
                  size="large"
                  type="submit"
                  disabled={submitting}
                  label="Enregistrer"
                />
              </div>
            </div>
          </section>
          <section className="formWrapper">
            <div className="form__field form__field--small">
              <h4 className="formWrapper__title">{t('password')}</h4>
            </div>
            <div className="form__field form__field--small button-2FA button-2FA--small">
              <Button
                label="Modifier mon mot de passe"
                type="button"
                size="large"
                button="primary"
                onClick={this.onHandleUpdatePassword}
              />
            </div>
          </section>
          <section className="formWrapper formWrapper--noBorder">
            <h4 className="formWrapper__title mb-25">{t('configure_auth')}</h4>
            <div
              className="customform__row customformGroup"
              style={{ display: 'flex', flexFlow: 'column' }}
            >
              <p
                style={{ margin: 'inherit', fontSize: '14px' }}
                className="customform__desc"
              >
                {t('configure_auth_desc')}
              </p>
              <div className="customform__row alert-form">
                {t('double_auth')} {user?.has2FA ? t('enable') : t('disabled')}
              </div>
              <div className="mr-15 button-2FA">
                <Button
                  label={user?.has2FA ? 'Désactiver 2FA' : 'Activer 2FA'}
                  type="button"
                  size="large"
                  button="primary"
                  onClick={this.onHandle2FA}
                />
              </div>
            </div>
          </section>
        </div>
      </form>
    )
  }
}

const Profile = reduxForm<any, any, any>({
  form: PROFILE_FORM,
  enableReinitialize: true,
})(ProfileForm)

const mapStateToProps = (state: any) => {
  const values = getFormValues(PROFILE_FORM)(state) || {}

  const {
    user: {
      user,
    },
  } = state

  return {
    ...values,
    user,
    initialValues: {
      ...user,
    },
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return {
    update: (body: any) => dispatch(getUpdateProfile(body)),
    activateSecureUserAccount: (body: any) => dispatch(activateSecureUserAccount(body)),
    disable2FA: () => dispatch(disable2FA()),
    getUserById: id => dispatch(getUserById(id)),
    setShowFormModal: () => dispatch(setShowFormModal()),
    setHideModal: () => dispatch(setHideModal()),
  }
}

export default compose<any>(
  withRouter,
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(Profile)
